module.exports = __webpack_public_path__ + "img/pr-4.d05fe2dc.png";